import { gql, TypedDocumentNode } from '@common/hooks';

// All enums keys must be registered here in alphabetical order (asc)
export type AvailableEnumsKeys =
  | 'AlliedHealthNursingLicenseType'
  | 'ApprovalChainRejectionReasons'
  | 'AssignmentCancelledReason'
  | 'DeclineSpearfishingReasonType'
  | 'OfferRejectionReasons'
  | 'RoleLevels'
  | 'SpearfishingMessageTypeDescription'
  | 'StaffingRequestApplicationRejectionReasonsInputs'
  | 'StaffingRequestTypes'
  | 'WorksListItemRejectionReasons'
  | 'WorksShiftType'
  | 'YearsOfExperience'
  | 'EmploymentTypes';

export type EnumQueryVariablesType = {
  key: AvailableEnumsKeys;
};

export type EnumType = {
  name: string;
  description: string;
};

type EnumQueryResponseType = {
  enum: EnumType[];
};

export const ENUM_QUERY: TypedDocumentNode<
  EnumQueryResponseType,
  EnumQueryVariablesType
> = gql`
  query EnumQuery($key: String!) {
    enum(key: $key) {
      name
      description
    }
  }
`;
